// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.forms-container {
  padding: 20px;
  color: white;
}

.tabs {
  display: flex;
  gap: 10px;
}

.tab {
  padding: 8px 16px;
  background: transparent;
  border: none;
  color: #fff;
  cursor: pointer;
  font-size: 14px;
  border-radius: 4px;
  transition: background-color 0.3s;
}

.tab:hover {
  background: rgba(255, 255, 255, 0.1);
}

.tab.active {
  background: #2196F3;
}

.content-area {
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

.button-area {
  padding: 20px 0px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.add-button {
  background-color: #2196F3;
  color: white;
  border: none;
  padding: 8px 16px;
  height: 36px;
  border-radius: 4px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
}

.add-button:hover {
  background-color: #1976D2;
}

.forms-grid {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 1rem;
  max-width: 1200px;
  margin: 0 auto;
}

h1 {
  color: #94a3b8;
  font-size: 1.875rem;
  margin-bottom: 2rem;
}

.form-card {
  background-color: #1e293b;
  border-radius: 0.5rem;
  padding: 1.5rem;
  text-decoration: none;
  color: white;
  transition: transform 0.2s;
  width: 180px;
  margin: 0.5rem;
  pointer-events: auto;
}

.form-card:hover {
  transform: translateY(-2px);
}

.card-content {
  text-align: center;
}

.card-icon {
  font-size: 2rem;
  color: #3b82f6;
  margin-bottom: 1rem;
}

h2 {
  margin: 0;
  font-size: 1.25rem;
}

.form-tile .button-group {
  display: flex;
  gap: 8px;
  margin-top: 12px;
}

.form-tile .delete-button {
  background: none;
  border: none;
  cursor: pointer;
  color: #e53e3e;
  padding: 8px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s;
}

.form-tile .delete-button:hover {
  background-color: rgba(229, 62, 62, 0.1);
}

.form-tile .delete-button svg {
  width: 16px;
  height: 16px;
}

.table-container {
  overflow-x: auto;
  position: relative;
  min-height: 200px;
}

table {
  width: 100%;
  border-collapse: collapse;
  color: white;
  position: relative;
  z-index: 1;
}

th, td {
  padding: 12px 15px;
  text-align: left;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

th {
  background-color: rgba(255, 255, 255, 0.1);
  font-weight: 600;
}

tr:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

td.group-cell,
td.location-cell,
td.type-cell {
  min-width: 200px;
  height: 60px;
  position: static;
}

.group-select {
  position: relative;
  min-width: 200px;
  width: 100%;
}

.group-select__menu,
.location-select__menu,
.type-select__menu {
  background-color: #011029 !important;
  border: 1px solid rgba(255, 255, 255, 0.2) !important;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1) !important;
  margin-top: 0;
  z-index: 999;
  position: absolute;
  width: 100%;
}

.group-select__menu-list,
.location-select__menu-list,
.type-select__menu-list {
  background-color: #011029 !important;
  padding: 0;
}

.group-select__option,
.location-select__option,
.type-select__option {
  background-color: #011029 !important;
  color: white !important;
  padding: 8px 12px;
}

.group-select__option:hover,
.group-select__option--is-focused,
.location-select__option:hover,
.location-select__option--is-focused,
.type-select__option:hover,
.type-select__option--is-focused {
  background-color: rgba(255, 255, 255, 0.1) !important;
}

.group-select__control,
.location-select__control,
.type-select__control {
  background-color: rgba(255, 255, 255, 0.1) !important;
  border-color: rgba(255, 255, 255, 0.2) !important;
  min-height: 38px;
  cursor: pointer;
}

.group-select__control:hover,
.location-select__control:hover,
.type-select__control:hover {
  border-color: #2196F3 !important;
}

.group-select__value-container,
.location-select__value-container,
.type-select__value-container {
  padding: 2px 8px;
}

.group-select__multi-value,
.location-select__multi-value,
.type-select__multi-value {
  background-color: rgba(255, 255, 255, 0.1) !important;
  border-radius: 2px;
  margin: 2px;
}

.group-select__multi-value__label,
.location-select__multi-value__label,
.type-select__multi-value__label {
  color: white !important;
  padding: 2px 6px;
}

.group-select__multi-value__remove,
.location-select__multi-value__remove {
  color: white !important;
  padding: 2px 6px;
  cursor: pointer;
}

.group-select__multi-value__remove:hover,
.location-select__multi-value__remove:hover {
  background-color: rgba(244, 67, 54, 0.2) !important;
  color: #f44336 !important;
}

.group-select__menu-portal,
.location-select__menu-portal {
  position: fixed;
  z-index: 9999;
}

.group-cell {
  min-width: 200px;
  padding: 8px !important;
  width: 200px;
}

.locations-container {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 0.5rem;
}

.location-checkbox {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
}

.location-checkbox input[type="checkbox"] {
  margin: 0;
  cursor: pointer;
}

.location-name {
  font-size: 0.9rem;
  color: white;
}

.action-buttons {
  display: flex;
  gap: 12px;
  justify-content: center;
  align-items: center;
}

.action-buttons svg {
  width: 16px;
  height: 16px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.delete-icon {
  color: #e53e3e;
  width: 16px;
  height: 16px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.delete-icon:hover {
  transform: scale(1.1);
  color: #ff4444;
}

.edit-icon,
.copy-icon {
  cursor: pointer;
  padding: 4px;
  width: 20px;
  height: 20px;
  color: #2196F3;
  transition: color 0.2s;
}

.edit-icon:hover,
.copy-icon:hover {
  color: #1976D2;
}

.delete-icon {
  color: #e53e3e;
  cursor: pointer;
  padding: 4px;
  width: 20px;
  height: 20px;
  transition: color 0.2s;
}

.delete-icon:hover {
  color: #c53030;
}

.location-select-container {
  width: 100%;
  color: white;
  position: relative;
}

.location-select__control {
  background-color: rgba(255, 255, 255, 0.1) !important;
  border-color: rgba(255, 255, 255, 0.2) !important;
  min-height: 38px;
}

.location-select__control:hover {
  border-color: #2196F3 !important;
}

.location-select__menu {
  background-color: #011029 !important;
  border: 1px solid rgba(255, 255, 255, 0.2) !important;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1) !important;
  z-index: 999 !important;
  position: absolute !important;
}

.location-select__option {
  background-color: transparent !important;
  color: white !important;
}

.location-select__option--is-focused {
  background-color: rgba(255, 255, 255, 0.1) !important;
}

.location-select__option:active {
  background-color: rgba(255, 255, 255, 0.2) !important;
}

.location-select__multi-value {
  background-color: rgba(255, 255, 255, 0.1) !important;
}

.location-select__multi-value__label {
  color: white !important;
}

.location-select__multi-value__remove {
  color: white !important;
}

.location-select__multi-value__remove:hover {
  background-color: rgba(244, 67, 54, 0.2) !important;
  color: #f44336 !important;
}

.location-select__input {
  color: white !important;
}

.editable-cell {
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  transition: background-color 0.2s;
}

.editable-cell:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.editable-input {
  width: 100%;
  padding: 4px 8px;
  background-color: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 4px;
  color: white;
  font-size: inherit;
}

.editable-input:focus {
  outline: none;
  border-color: #2196F3;
  background-color: rgba(255, 255, 255, 0.15);
}

.type-cell {
  min-width: 200px;
  height: 60px;
  position: static;
}

.type-select {
  position: relative;
  min-width: 200px;
  width: 100%;
}

.type-select__control {
  background-color: rgba(255, 255, 255, 0.1) !important;
  border-color: rgba(255, 255, 255, 0.2) !important;
  min-height: 38px !important;
  height: 38px !important;
  cursor: pointer !important;
}

.type-select__control:hover {
  border-color: #2196F3 !important;
}

.type-select__menu {
  background-color: #011029 !important;
  border: 1px solid rgba(255, 255, 255, 0.2) !important;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1) !important;
  margin-top: 0;
  z-index: 9999 !important;
}

.type-select__menu-list {
  background-color: #011029 !important;
  padding: 0;
}

.type-select__option {
  background-color: #011029 !important;
  color: white !important;
  padding: 8px 12px !important;
}

.type-select__option:hover,
.type-select__option--is-focused {
  background-color: rgba(255, 255, 255, 0.1) !important;
}

.type-select__single-value {
  color: white !important;
}

.type-select__placeholder {
  color: rgba(255, 255, 255, 0.5) !important;
}

.type-select__indicator {
  color: rgba(255, 255, 255, 0.5) !important;
}

.type-select__indicator:hover {
  color: rgba(255, 255, 255, 0.8) !important;
}

.type-select__value-container {
  padding: 2px 8px !important;
  height: 38px !important;
}

.copy-icon {
  color: #64b5f6;
  cursor: pointer;
  margin: 0 8px;
  transition: color 0.2s ease;
}

.copy-icon:hover {
  color: #2196f3;
}

.share-icon {
  color: #81c784;
  cursor: pointer;
  margin: 0 8px;
  transition: color 0.2s ease;
}

.share-icon:hover {
  color: #4caf50;
}

.schedule-actions {
  display: flex;
  gap: 8px;
  justify-content: flex-start;
  align-items: center;
}

.schedule-button svg {
  width: 18px;
  height: 18px;
}

.schedule-button {
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: white;
  padding: 6px 12px;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.3s ease;
}

.schedule-button:hover {
  background: rgba(255, 255, 255, 0.1);
}

.form-container {
  max-width: 880px;
  width: 100%;
  margin: 0 auto;
  padding: 1rem;
}

.form-content {
  background-color: #1e293b;
  border-radius: 8px;
  padding: 1.5rem;
  width: 100%;
  margin: 0 auto;
}

.form-section {
  margin-bottom: 2rem;
  border-radius: 8px;
  background: none !important;
  transition: none !important;
  transform: none !important;
}

.form-section:hover {
  background: none !important;
  transform: none !important;
}

.form-section > * {
  pointer-events: auto;
}

.form-section h3 {
  color: #e2e8f0;
  font-size: 1.25rem;
  margin-bottom: 1.5rem;
  font-weight: 600;
}

.form-group {
  margin-bottom: 1.5rem;
}

/* Form Sections */
.form-section {

}

.form-section h2 {
  color: white;
  margin-bottom: 20px;
  padding-left: 20px;
  border-left: 4px solid #4299e1;
}

/* Form Subsections */
.form-subsection {
  margin: 1.5rem 0;
  padding: 1.25rem;
  border-radius: 6px;
}

.form-subsection h4 {
  color: #e2e8f0;
  font-size: 1.1rem;
  margin-bottom: 1rem;
  font-weight: 500;
}

/* Form Grid and Tiles */
.form-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
  padding: 20px;
}

.form-tile {
  background: #1e293b;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  padding: 16px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  transition: all 0.2s ease-in-out;
  position: relative;
  overflow: hidden;
  width: 100%;
  color: #e2e8f0;
  cursor: pointer;
}

.form-tile:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);
  background: #2d3b4f;
}

.form-tile-content {
  display: flex;
  align-items: center;
  gap: 24px;
  flex: 1 1;
}

.form-tile h3 {
  color: #e2e8f0;
  font-size: 1.1rem;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 200px;
}

.form-tile .timestamp {
  color: #94a3b8;
  font-size: 0.9rem;
  white-space: nowrap;
}

.preview-field {
  color: #94a3b8;
  font-size: 0.9rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.form-actions {
  display: flex;
  gap: 8px;
  margin-left: auto;
}

.action-button {
  background: none;
  border: none;
  padding: 8px;
  cursor: pointer;
  border-radius: 4px;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #f56565;
  font-size: 1.1rem;
}

.action-button:hover {
  background-color: rgba(245, 101, 101, 0.1);
  transform: scale(1.1);
}

.action-button.delete {
  color: #f56565;
}

.action-button.delete:hover {
  background-color: rgba(245, 101, 101, 0.1);
}

/* Messages */
.empty-message {
  text-align: center;
  color: #718096;
  padding: 40px;
  font-style: italic;
  background: #f7fafc;
  border-radius: 8px;
  margin: 20px;
}

.error-message {
  background-color: #fff5f5;
  color: #c53030;
  padding: 12px 20px;
  border-radius: 6px;
  margin: 20px;
  border-left: 4px solid #f56565;
}

.loading {
  text-align: center;
  padding: 40px;
  color: #4299e1;
  font-weight: 500;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .form-container {
    padding: 0.75rem;
  }

  .form-content {
    padding: 1rem;
    border-radius: 0;
    min-height: 100vh;
  }
}

/* Ensure form inputs and controls are properly sized */
.form-control,
.form-select,
.form-textarea {
  width: 100%;
  max-width: 100%;
}

/* Form Fields */
.form-field {
  margin-bottom: 1.5rem;
  padding: 1rem;
  border-radius: 6px;
}

.form-field label {
  display: block;
  color: #e2e8f0;
  margin-bottom: 0.75rem;
  font-weight: 500;
}

.form-field input[type="text"],
.form-field input[type="number"],
.form-field textarea {
  width: 100%;
  padding: 0.75rem;
  background: rgba(15, 23, 42, 0.6);
  border: 1px solid #475569;
  border-radius: 4px;
  color: #e2e8f0;
  font-size: 1rem;
}

.form-field-content {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.form-field-content h3,
.form-field-content h4 {
  margin: 0;
  flex: 1 1;
}

.form-field-checkbox {
  width: 20px;
  height: 20px;
  cursor: pointer;
  accent-color: #2563eb;
  flex-shrink: 0;
}

.form-field-text {
  color: #e2e8f0;
  font-size: 1rem;
  flex: 1 1;
}

/* Form row indentation and hover effects */
.form-section {
  margin-left: 0;
  cursor: pointer;
}

.form-subsection {
  margin-left: 2rem;
  cursor: pointer;
}

.form-field {
  margin-left: 4rem;
  cursor: pointer;
}

.form-section:hover,
.form-subsection:hover,
.form-field:hover {
  background: rgba(255, 255, 255, 0.05);
}

/* Completed item styles */
.form-section.completed h3,
.form-subsection.completed h4,
.form-field.completed .form-field-text {
  text-decoration: line-through;
  color: #64748b;
  opacity: 0.8;
}

.form-section.completed,
.form-subsection.completed,
.form-field.completed {
  background-color: rgba(30, 41, 59, 0.2);
}

/* Form Footer and Buttons */
.form-footer {
  margin-top: 3rem;
  padding: 1.5rem;
  display: flex;
  justify-content: center;
  gap: 1rem;
}

.button-group {
  display: flex;
  gap: 1.5rem;
}

.cancel-button,
.submit-button {
  padding: 0.75rem 2rem;
  border-radius: 6px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 120px;
}

.cancel-button {
  background: transparent;
  border: 1px solid #475569;
  color: #94a3b8;
}

.cancel-button:hover {
  border-color: #64748b;
  color: #e2e8f0;
  background: rgba(255, 255, 255, 0.05);
}

.submit-button {
  background: #2563eb;
  border: none;
  color: white;
}

.submit-button:hover {
  background: #1d4ed8;
}

.submit-button:disabled {
  background: #475569;
  cursor: not-allowed;
  opacity: 0.7;
}`, "",{"version":3,"sources":["webpack://./src/components/forms/Forms.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;EACjB,iDAAiD;AACnD;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,qBAAqB;EACrB,YAAY;EACZ,0BAA0B;EAC1B,YAAY;EACZ,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;AACnC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iDAAiD;AACnD;;AAEA;EACE,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;;;EAGE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;;;EAGE,oCAAoC;EACpC,qDAAqD;EACrD,mDAAmD;EACnD,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,WAAW;AACb;;AAEA;;;EAGE,oCAAoC;EACpC,UAAU;AACZ;;AAEA;;;EAGE,oCAAoC;EACpC,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;;;;;;EAME,qDAAqD;AACvD;;AAEA;;;EAGE,qDAAqD;EACrD,iDAAiD;EACjD,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;;EAGE,gCAAgC;AAClC;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;;;EAGE,qDAAqD;EACrD,kBAAkB;EAClB,WAAW;AACb;;AAEA;;;EAGE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;;EAEE,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,mDAAmD;EACnD,yBAAyB;AAC3B;;AAEA;;EAEE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;EAEE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,cAAc;EACd,sBAAsB;AACxB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,qDAAqD;EACrD,iDAAiD;EACjD,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,qDAAqD;EACrD,mDAAmD;EACnD,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,wCAAwC;EACxC,uBAAuB;AACzB;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mDAAmD;EACnD,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,0CAA0C;EAC1C,0CAA0C;EAC1C,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,qDAAqD;EACrD,iDAAiD;EACjD,2BAA2B;EAC3B,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,qDAAqD;EACrD,mDAAmD;EACnD,aAAa;EACb,wBAAwB;AAC1B;;AAEA;EACE,oCAAoC;EACpC,UAAU;AACZ;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;;EAEE,qDAAqD;AACvD;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,0CAA0C;EAC1C,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,2BAA2B;EAC3B,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,kBAAkB;AAClB;;AAEA;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA,qBAAqB;AACrB;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,wCAAwC;EACxC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAO;AACT;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,0CAA0C;EAC1C,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA,aAAa;AACb;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,gBAAgB;IAChB,iBAAiB;EACnB;AACF;;AAEA,uDAAuD;AACvD;;;EAGE,WAAW;EACX,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,qBAAqB;EACrB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;;;EAGE,WAAW;EACX,gBAAgB;EAChB,iCAAiC;EACjC,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;;EAEE,SAAS;EACT,SAAO;AACT;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,SAAO;AACT;;AAEA,2CAA2C;AAC3C;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;;;EAGE,qCAAqC;AACvC;;AAEA,0BAA0B;AAC1B;;;EAGE,6BAA6B;EAC7B,cAAc;EACd,YAAY;AACd;;AAEA;;;EAGE,uCAAuC;AACzC;;AAEA,4BAA4B;AAC5B;EACE,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;;EAEE,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd","sourcesContent":[".forms-container {\n  padding: 20px;\n  color: white;\n}\n\n.tabs {\n  display: flex;\n  gap: 10px;\n}\n\n.tab {\n  padding: 8px 16px;\n  background: transparent;\n  border: none;\n  color: #fff;\n  cursor: pointer;\n  font-size: 14px;\n  border-radius: 4px;\n  transition: background-color 0.3s;\n}\n\n.tab:hover {\n  background: rgba(255, 255, 255, 0.1);\n}\n\n.tab.active {\n  background: #2196F3;\n}\n\n.content-area {\n  border-radius: 4px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\n}\n\n.button-area {\n  padding: 20px 0px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.add-button {\n  background-color: #2196F3;\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  height: 36px;\n  border-radius: 4px;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n}\n\n.add-button:hover {\n  background-color: #1976D2;\n}\n\n.forms-grid {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 1rem;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\nh1 {\n  color: #94a3b8;\n  font-size: 1.875rem;\n  margin-bottom: 2rem;\n}\n\n.form-card {\n  background-color: #1e293b;\n  border-radius: 0.5rem;\n  padding: 1.5rem;\n  text-decoration: none;\n  color: white;\n  transition: transform 0.2s;\n  width: 180px;\n  margin: 0.5rem;\n  pointer-events: auto;\n}\n\n.form-card:hover {\n  transform: translateY(-2px);\n}\n\n.card-content {\n  text-align: center;\n}\n\n.card-icon {\n  font-size: 2rem;\n  color: #3b82f6;\n  margin-bottom: 1rem;\n}\n\nh2 {\n  margin: 0;\n  font-size: 1.25rem;\n}\n\n.form-tile .button-group {\n  display: flex;\n  gap: 8px;\n  margin-top: 12px;\n}\n\n.form-tile .delete-button {\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: #e53e3e;\n  padding: 8px;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background-color 0.2s;\n}\n\n.form-tile .delete-button:hover {\n  background-color: rgba(229, 62, 62, 0.1);\n}\n\n.form-tile .delete-button svg {\n  width: 16px;\n  height: 16px;\n}\n\n.table-container {\n  overflow-x: auto;\n  position: relative;\n  min-height: 200px;\n}\n\ntable {\n  width: 100%;\n  border-collapse: collapse;\n  color: white;\n  position: relative;\n  z-index: 1;\n}\n\nth, td {\n  padding: 12px 15px;\n  text-align: left;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n}\n\nth {\n  background-color: rgba(255, 255, 255, 0.1);\n  font-weight: 600;\n}\n\ntr:hover {\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\ntd.group-cell,\ntd.location-cell,\ntd.type-cell {\n  min-width: 200px;\n  height: 60px;\n  position: static;\n}\n\n.group-select {\n  position: relative;\n  min-width: 200px;\n  width: 100%;\n}\n\n.group-select__menu,\n.location-select__menu,\n.type-select__menu {\n  background-color: #011029 !important;\n  border: 1px solid rgba(255, 255, 255, 0.2) !important;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1) !important;\n  margin-top: 0;\n  z-index: 999;\n  position: absolute;\n  width: 100%;\n}\n\n.group-select__menu-list,\n.location-select__menu-list,\n.type-select__menu-list {\n  background-color: #011029 !important;\n  padding: 0;\n}\n\n.group-select__option,\n.location-select__option,\n.type-select__option {\n  background-color: #011029 !important;\n  color: white !important;\n  padding: 8px 12px;\n}\n\n.group-select__option:hover,\n.group-select__option--is-focused,\n.location-select__option:hover,\n.location-select__option--is-focused,\n.type-select__option:hover,\n.type-select__option--is-focused {\n  background-color: rgba(255, 255, 255, 0.1) !important;\n}\n\n.group-select__control,\n.location-select__control,\n.type-select__control {\n  background-color: rgba(255, 255, 255, 0.1) !important;\n  border-color: rgba(255, 255, 255, 0.2) !important;\n  min-height: 38px;\n  cursor: pointer;\n}\n\n.group-select__control:hover,\n.location-select__control:hover,\n.type-select__control:hover {\n  border-color: #2196F3 !important;\n}\n\n.group-select__value-container,\n.location-select__value-container,\n.type-select__value-container {\n  padding: 2px 8px;\n}\n\n.group-select__multi-value,\n.location-select__multi-value,\n.type-select__multi-value {\n  background-color: rgba(255, 255, 255, 0.1) !important;\n  border-radius: 2px;\n  margin: 2px;\n}\n\n.group-select__multi-value__label,\n.location-select__multi-value__label,\n.type-select__multi-value__label {\n  color: white !important;\n  padding: 2px 6px;\n}\n\n.group-select__multi-value__remove,\n.location-select__multi-value__remove {\n  color: white !important;\n  padding: 2px 6px;\n  cursor: pointer;\n}\n\n.group-select__multi-value__remove:hover,\n.location-select__multi-value__remove:hover {\n  background-color: rgba(244, 67, 54, 0.2) !important;\n  color: #f44336 !important;\n}\n\n.group-select__menu-portal,\n.location-select__menu-portal {\n  position: fixed;\n  z-index: 9999;\n}\n\n.group-cell {\n  min-width: 200px;\n  padding: 8px !important;\n  width: 200px;\n}\n\n.locations-container {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  padding: 0.5rem;\n}\n\n.location-checkbox {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  cursor: pointer;\n}\n\n.location-checkbox input[type=\"checkbox\"] {\n  margin: 0;\n  cursor: pointer;\n}\n\n.location-name {\n  font-size: 0.9rem;\n  color: white;\n}\n\n.action-buttons {\n  display: flex;\n  gap: 12px;\n  justify-content: center;\n  align-items: center;\n}\n\n.action-buttons svg {\n  width: 16px;\n  height: 16px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.delete-icon {\n  color: #e53e3e;\n  width: 16px;\n  height: 16px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.delete-icon:hover {\n  transform: scale(1.1);\n  color: #ff4444;\n}\n\n.edit-icon,\n.copy-icon {\n  cursor: pointer;\n  padding: 4px;\n  width: 20px;\n  height: 20px;\n  color: #2196F3;\n  transition: color 0.2s;\n}\n\n.edit-icon:hover,\n.copy-icon:hover {\n  color: #1976D2;\n}\n\n.delete-icon {\n  color: #e53e3e;\n  cursor: pointer;\n  padding: 4px;\n  width: 20px;\n  height: 20px;\n  transition: color 0.2s;\n}\n\n.delete-icon:hover {\n  color: #c53030;\n}\n\n.location-select-container {\n  width: 100%;\n  color: white;\n  position: relative;\n}\n\n.location-select__control {\n  background-color: rgba(255, 255, 255, 0.1) !important;\n  border-color: rgba(255, 255, 255, 0.2) !important;\n  min-height: 38px;\n}\n\n.location-select__control:hover {\n  border-color: #2196F3 !important;\n}\n\n.location-select__menu {\n  background-color: #011029 !important;\n  border: 1px solid rgba(255, 255, 255, 0.2) !important;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1) !important;\n  z-index: 999 !important;\n  position: absolute !important;\n}\n\n.location-select__option {\n  background-color: transparent !important;\n  color: white !important;\n}\n\n.location-select__option--is-focused {\n  background-color: rgba(255, 255, 255, 0.1) !important;\n}\n\n.location-select__option:active {\n  background-color: rgba(255, 255, 255, 0.2) !important;\n}\n\n.location-select__multi-value {\n  background-color: rgba(255, 255, 255, 0.1) !important;\n}\n\n.location-select__multi-value__label {\n  color: white !important;\n}\n\n.location-select__multi-value__remove {\n  color: white !important;\n}\n\n.location-select__multi-value__remove:hover {\n  background-color: rgba(244, 67, 54, 0.2) !important;\n  color: #f44336 !important;\n}\n\n.location-select__input {\n  color: white !important;\n}\n\n.editable-cell {\n  cursor: pointer;\n  padding: 4px 8px;\n  border-radius: 4px;\n  transition: background-color 0.2s;\n}\n\n.editable-cell:hover {\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n.editable-input {\n  width: 100%;\n  padding: 4px 8px;\n  background-color: rgba(255, 255, 255, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 4px;\n  color: white;\n  font-size: inherit;\n}\n\n.editable-input:focus {\n  outline: none;\n  border-color: #2196F3;\n  background-color: rgba(255, 255, 255, 0.15);\n}\n\n.type-cell {\n  min-width: 200px;\n  height: 60px;\n  position: static;\n}\n\n.type-select {\n  position: relative;\n  min-width: 200px;\n  width: 100%;\n}\n\n.type-select__control {\n  background-color: rgba(255, 255, 255, 0.1) !important;\n  border-color: rgba(255, 255, 255, 0.2) !important;\n  min-height: 38px !important;\n  height: 38px !important;\n  cursor: pointer !important;\n}\n\n.type-select__control:hover {\n  border-color: #2196F3 !important;\n}\n\n.type-select__menu {\n  background-color: #011029 !important;\n  border: 1px solid rgba(255, 255, 255, 0.2) !important;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1) !important;\n  margin-top: 0;\n  z-index: 9999 !important;\n}\n\n.type-select__menu-list {\n  background-color: #011029 !important;\n  padding: 0;\n}\n\n.type-select__option {\n  background-color: #011029 !important;\n  color: white !important;\n  padding: 8px 12px !important;\n}\n\n.type-select__option:hover,\n.type-select__option--is-focused {\n  background-color: rgba(255, 255, 255, 0.1) !important;\n}\n\n.type-select__single-value {\n  color: white !important;\n}\n\n.type-select__placeholder {\n  color: rgba(255, 255, 255, 0.5) !important;\n}\n\n.type-select__indicator {\n  color: rgba(255, 255, 255, 0.5) !important;\n}\n\n.type-select__indicator:hover {\n  color: rgba(255, 255, 255, 0.8) !important;\n}\n\n.type-select__value-container {\n  padding: 2px 8px !important;\n  height: 38px !important;\n}\n\n.copy-icon {\n  color: #64b5f6;\n  cursor: pointer;\n  margin: 0 8px;\n  transition: color 0.2s ease;\n}\n\n.copy-icon:hover {\n  color: #2196f3;\n}\n\n.share-icon {\n  color: #81c784;\n  cursor: pointer;\n  margin: 0 8px;\n  transition: color 0.2s ease;\n}\n\n.share-icon:hover {\n  color: #4caf50;\n}\n\n.schedule-actions {\n  display: flex;\n  gap: 8px;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.schedule-button svg {\n  width: 18px;\n  height: 18px;\n}\n\n.schedule-button {\n  background: transparent;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  color: white;\n  padding: 6px 12px;\n  border-radius: 4px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  transition: all 0.3s ease;\n}\n\n.schedule-button:hover {\n  background: rgba(255, 255, 255, 0.1);\n}\n\n.form-container {\n  max-width: 880px;\n  width: 100%;\n  margin: 0 auto;\n  padding: 1rem;\n}\n\n.form-content {\n  background-color: #1e293b;\n  border-radius: 8px;\n  padding: 1.5rem;\n  width: 100%;\n  margin: 0 auto;\n}\n\n.form-section {\n  margin-bottom: 2rem;\n  border-radius: 8px;\n  background: none !important;\n  transition: none !important;\n  transform: none !important;\n}\n\n.form-section:hover {\n  background: none !important;\n  transform: none !important;\n}\n\n.form-section > * {\n  pointer-events: auto;\n}\n\n.form-section h3 {\n  color: #e2e8f0;\n  font-size: 1.25rem;\n  margin-bottom: 1.5rem;\n  font-weight: 600;\n}\n\n.form-group {\n  margin-bottom: 1.5rem;\n}\n\n/* Form Sections */\n.form-section {\n\n}\n\n.form-section h2 {\n  color: white;\n  margin-bottom: 20px;\n  padding-left: 20px;\n  border-left: 4px solid #4299e1;\n}\n\n/* Form Subsections */\n.form-subsection {\n  margin: 1.5rem 0;\n  padding: 1.25rem;\n  border-radius: 6px;\n}\n\n.form-subsection h4 {\n  color: #e2e8f0;\n  font-size: 1.1rem;\n  margin-bottom: 1rem;\n  font-weight: 500;\n}\n\n/* Form Grid and Tiles */\n.form-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 20px;\n  padding: 20px;\n}\n\n.form-tile {\n  background: #1e293b;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n  padding: 16px 24px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 20px;\n  transition: all 0.2s ease-in-out;\n  position: relative;\n  overflow: hidden;\n  width: 100%;\n  color: #e2e8f0;\n  cursor: pointer;\n}\n\n.form-tile:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);\n  background: #2d3b4f;\n}\n\n.form-tile-content {\n  display: flex;\n  align-items: center;\n  gap: 24px;\n  flex: 1;\n}\n\n.form-tile h3 {\n  color: #e2e8f0;\n  font-size: 1.1rem;\n  margin: 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  min-width: 200px;\n}\n\n.form-tile .timestamp {\n  color: #94a3b8;\n  font-size: 0.9rem;\n  white-space: nowrap;\n}\n\n.preview-field {\n  color: #94a3b8;\n  font-size: 0.9rem;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.form-actions {\n  display: flex;\n  gap: 8px;\n  margin-left: auto;\n}\n\n.action-button {\n  background: none;\n  border: none;\n  padding: 8px;\n  cursor: pointer;\n  border-radius: 4px;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #f56565;\n  font-size: 1.1rem;\n}\n\n.action-button:hover {\n  background-color: rgba(245, 101, 101, 0.1);\n  transform: scale(1.1);\n}\n\n.action-button.delete {\n  color: #f56565;\n}\n\n.action-button.delete:hover {\n  background-color: rgba(245, 101, 101, 0.1);\n}\n\n/* Messages */\n.empty-message {\n  text-align: center;\n  color: #718096;\n  padding: 40px;\n  font-style: italic;\n  background: #f7fafc;\n  border-radius: 8px;\n  margin: 20px;\n}\n\n.error-message {\n  background-color: #fff5f5;\n  color: #c53030;\n  padding: 12px 20px;\n  border-radius: 6px;\n  margin: 20px;\n  border-left: 4px solid #f56565;\n}\n\n.loading {\n  text-align: center;\n  padding: 40px;\n  color: #4299e1;\n  font-weight: 500;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .form-container {\n    padding: 0.75rem;\n  }\n\n  .form-content {\n    padding: 1rem;\n    border-radius: 0;\n    min-height: 100vh;\n  }\n}\n\n/* Ensure form inputs and controls are properly sized */\n.form-control,\n.form-select,\n.form-textarea {\n  width: 100%;\n  max-width: 100%;\n}\n\n/* Form Fields */\n.form-field {\n  margin-bottom: 1.5rem;\n  padding: 1rem;\n  border-radius: 6px;\n}\n\n.form-field label {\n  display: block;\n  color: #e2e8f0;\n  margin-bottom: 0.75rem;\n  font-weight: 500;\n}\n\n.form-field input[type=\"text\"],\n.form-field input[type=\"number\"],\n.form-field textarea {\n  width: 100%;\n  padding: 0.75rem;\n  background: rgba(15, 23, 42, 0.6);\n  border: 1px solid #475569;\n  border-radius: 4px;\n  color: #e2e8f0;\n  font-size: 1rem;\n}\n\n.form-field-content {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.form-field-content h3,\n.form-field-content h4 {\n  margin: 0;\n  flex: 1;\n}\n\n.form-field-checkbox {\n  width: 20px;\n  height: 20px;\n  cursor: pointer;\n  accent-color: #2563eb;\n  flex-shrink: 0;\n}\n\n.form-field-text {\n  color: #e2e8f0;\n  font-size: 1rem;\n  flex: 1;\n}\n\n/* Form row indentation and hover effects */\n.form-section {\n  margin-left: 0;\n  cursor: pointer;\n}\n\n.form-subsection {\n  margin-left: 2rem;\n  cursor: pointer;\n}\n\n.form-field {\n  margin-left: 4rem;\n  cursor: pointer;\n}\n\n.form-section:hover,\n.form-subsection:hover,\n.form-field:hover {\n  background: rgba(255, 255, 255, 0.05);\n}\n\n/* Completed item styles */\n.form-section.completed h3,\n.form-subsection.completed h4,\n.form-field.completed .form-field-text {\n  text-decoration: line-through;\n  color: #64748b;\n  opacity: 0.8;\n}\n\n.form-section.completed,\n.form-subsection.completed,\n.form-field.completed {\n  background-color: rgba(30, 41, 59, 0.2);\n}\n\n/* Form Footer and Buttons */\n.form-footer {\n  margin-top: 3rem;\n  padding: 1.5rem;\n  display: flex;\n  justify-content: center;\n  gap: 1rem;\n}\n\n.button-group {\n  display: flex;\n  gap: 1.5rem;\n}\n\n.cancel-button,\n.submit-button {\n  padding: 0.75rem 2rem;\n  border-radius: 6px;\n  font-size: 1rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  min-width: 120px;\n}\n\n.cancel-button {\n  background: transparent;\n  border: 1px solid #475569;\n  color: #94a3b8;\n}\n\n.cancel-button:hover {\n  border-color: #64748b;\n  color: #e2e8f0;\n  background: rgba(255, 255, 255, 0.05);\n}\n\n.submit-button {\n  background: #2563eb;\n  border: none;\n  color: white;\n}\n\n.submit-button:hover {\n  background: #1d4ed8;\n}\n\n.submit-button:disabled {\n  background: #475569;\n  cursor: not-allowed;\n  opacity: 0.7;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
